import Spinner from 'components/Spinner';
import Card from 'components/Card';
import CardContent from 'components/CardContent';
import Note from 'components/Note';
import NoteForm from 'components/NoteForm';

import CustomerDetails from './components/CustomerDetails';
import DoctorDetails from './components/DoctorDetails';
import Header from './components/Header';
import Prescriptions from './components/Prescriptions';
import PreferenceTime from './components/PreferenceTime';
import Otcs from './components/Otcs';
import ListWrapper from 'components/ListWrapper';
import styles from './RequestDetails.module.scss';
import {Key, useRef, useState} from 'react';
import Modal from '../../components/Modal';
import Typography from '../../components/Typography';
import {get} from 'lodash';
import Button from '../../components/Button';
import FormGroup from 'components/FormGroup';
import {Controller} from 'react-hook-form';
import {GooglePlaceAutoComplete} from 'components/GooglePlaceAutoComplete';
import TextField from 'components/TextField';
import {
  Address,
  Note as NoteType,
  ScriptStatus,
  SupportRequestStatus,
  Transaction,
} from 'types';
import ArrowIcon from 'pages/UserForm/UserAddresses/ArrowIcon';
import MapPreview from 'components/MapPreview';
import useAuth from 'hooks/useAuth';
import {useReactToPrint} from 'react-to-print';
import PrintIcon from 'icons/PrintIcon';
import RefillHandler, {
  RefillProps,
} from 'pages/PrescriberPrescriptions/RefillHandler';
import SupportStatusSelect from 'pages/Support/SupportStatusSelect';

import useRequestDetails from './useRequestDetails';
import Select from 'components/Select';
import FormActionGroup from 'components/FormActionGroup';
import Checkbox from 'components/Checkbox';
import {PlusComponent} from 'pages/Requests/Requests';
import {useHistory} from 'react-router-dom';
import {CreditCardType} from 'components/CreditCardType';
import Rx2GoDetails from './components/Rx2GoDetails';
import InsuranceModal from 'components/InsuranceModal';

export const origin = {
  app: 'app',
  micromerchant: 'micromerchant',
  landing_page: 'app',
  dashboard: 'micromerchant',
  meta_ads: 'app',
  'app refill': 'app',
};

export const leadStatuses = {
  Lead: 'Lead (form signup)',
  Contact: 'Contact (spoke with them)',
  Subscribe: 'Subscribe (newsletter)',
  Purchase: 'Purchase (order)',
};

function RequestDetails() {
  const {currentUser} = useAuth();
  const [isPrescriber] = useState(currentUser?.role === 'prescriber');

  const {
    id,
    showInsurance,
    data,
    markDisabled,
    setShowInsurance,
    onChangeScriptStatus,
    onSubmitNote,
    complete,
    onUpdatePreference,
    refetch,
    onStatusChange,
    handleNotifyCustomer,
    handleRequestSignature,
    handleCreation,
    addressChangeHandler,
    cards,
    addressIsUpdating,
    handleModalClose,
    submitSelectedCard,
    onCharge,
    control,
    setValue,
    handleSubmit,
    onSelectPlace,
    location,
    modalOpen,
    openAddressModal,
    setOpenAddressModal,
    selectCardModal,
    setSelectCardModal,
    accessCardModal,
    setAccessCardModal,
    deliveryAddressId,
    setDeliveryAddressId,
    cardId,
    setCardIs,
    status,
    setStatus,
    modalHandler,
    sendLeadToMeta,
    isMessageModalOpen,
    setMessageModalOpen,
    message,
    setMessage,
    sendMessage,
    messageTemplates,
    selectedTemplate,
    setSelectedTemplate,
    sendChannels,
    setSendChannels,
    isStatusUpdating,
    rx2goDetails,
    isRx2GoDetailsLoading,
  } = useRequestDetails();
  const [showKits, setShowKits] = useState(false);
  const {push} = useHistory();
  const printRef = useRef<HTMLDivElement>(null);
  const refillRef = useRef<RefillProps>(null);
  const reactToPrintFn = useReactToPrint({
    content: () => printRef.current,
    onAfterPrint: () => setShowKits(false),
    pageStyle: '@page { size: auto; margin: 15mm; }',
  });

  const selectedCard = cards.find((item: any) => item.custom_uuid === cardId);
  const lastNoteWithRouteId = data?.notes?.findLast((note: NoteType) =>
    note.text.includes('Route ID')
  );
  const invalidExpiryDate =
    get(selectedCard, 'exp_month', '') === '0' ||
    get(selectedCard, 'exp_year', '') === '0';
  if (!data)
    return (
      <div className={styles.loading}>
        <Spinner />
      </div>
    );
  return (
    <div>
      <Header
        id={id}
        created_at={data.created_at}
        status={data.status}
        app={data.request_origin}
        is_resolved={data.is_resolved}
        completeDisabled={markDisabled}
        complete={complete}
        rx_no={
          data.prescriptions.length > 0
            ? get(data.prescriptions[0], 'rx_no', 0)
            : data.otcs.length > 0
            ? get(data.otcs[0], 'rx_no', 0)
            : 0
        }
        previous_id={data.previous_id}
        next_id={data.next_id}
      />
      {(get(data.prescriptions, '[0].meds_kit', []) || []).length > 0 &&
        isPrescriber && (
          <div className={styles.prescriber_buttons}>
            <Button
              onClick={() =>
                refillRef.current?.open(get(data.prescriptions, '[0].id', 0))
              }
              color="blue"
            >
              Refill
            </Button>
            <Button
              onClick={() => {
                setShowKits(true);
                setTimeout(reactToPrintFn, 1000);
              }}
              color="blue"
            >
              <PrintIcon size={16} />
            </Button>
          </div>
        )}

      <div
        ref={printRef}
        style={{
          flexDirection: showKits ? 'column' : 'row',
          gap: showKits ? 20 : 0,
        }}
        className={styles.content}
      >
        <div className={styles.main_content}>
          <CustomerDetails
            pharmacy={data.pharmacy}
            customer={data.customer}
            isOrder={
              origin[data.request_origin as keyof typeof origin] !== 'app'
            }
            deliveryData={data?.delivery_address}
            modalHandler={modalHandler}
            allergies={String(get(data, 'customer.allergies', '') || '')}
          />
          {!showKits && (
            <DoctorDetails
              request={data}
              showInsurance={() => setShowInsurance(true)}
            />
          )}

          <Card className={styles.noteInput}>
            <CardContent dark>
              <NoteForm
                source={origin[data.request_origin as keyof typeof origin]}
                isPrescriber={isPrescriber}
                isCompleted={
                  get(data, 'status', '') === 'completed' &&
                  !!get(data, 'route_id', null)
                }
                onSubmit={onSubmitNote}
              />
              {data.notes.map((note, index) => (
                <Note
                  key={note.id}
                  {...note}
                  transactions={(data?.transactions as Transaction[]) || []}
                  text={note.text}
                  isCompleted={
                    get(data, 'status', '') === 'completed' &&
                    index === 0 &&
                    !!get(data, 'route_id', null)
                  }
                  isRouteClickable={
                    !!lastNoteWithRouteId && note.id === lastNoteWithRouteId.id
                  }
                  order_id={data.id}
                  route_id={Number(get(data, 'route_id', null))}
                />
              ))}
            </CardContent>
          </Card>
        </div>
        <div className={styles.drugs}>
          <Button
            className={styles.smsButton}
            color="blue"
            onClick={() => setMessageModalOpen(true)}
          >
            Notify to Patient
          </Button>
          {origin[data.request_origin as keyof typeof origin] === 'app' &&
            data.status === 'call_doctor' && (
              <Card>
                <CardContent
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                  }}
                  pt="sm"
                >
                  <p>Status:</p>
                  <SupportStatusSelect
                    name={`support-request-${data.id}`}
                    status={
                      SupportRequestStatus[
                        data.is_resolved ? 'ARCHIVED' : 'ACTIVE'
                      ]
                    }
                    onChange={onStatusChange}
                  />
                </CardContent>
              </Card>
            )}
          {data.prescriptions.length > 0 && (
            <Prescriptions
              data={data}
              showKits={showKits}
              isPrescriber={isPrescriber}
              requestId={data.id}
              origin={origin[data.request_origin as keyof typeof origin]}
              drugs={data.prescriptions}
              status={status as ScriptStatus}
              isStatusUpdating={isStatusUpdating}
              onChangeStatus={(newVal, action) => {
                setStatus(get(newVal, 'value', '') as ScriptStatus);
                onChangeScriptStatus(newVal, action);
              }}
              sync_time={data.sync_time as string}
              sync_source={data.sync_source}
              onCharge={onCharge}
              onSendNotification={handleNotifyCustomer}
              onRequestSignature={handleRequestSignature}
            />
          )}

          <Otcs
            requestId={data.id}
            drugs={data.otcs}
            origin={data.only_otc ? 'micromerchant' : data.request_origin}
            onChangeStatus={onChangeScriptStatus}
          />
          {/* {data.sync_source === 'app' && data.request_origin === 'meta_ads' && (
            <Button onClick={sendLeadToMeta} className={styles.metaButton}>
              Send lead to Meta
            </Button>
          )} */}
          {data.sync_source === 'app' && data.request_origin === 'meta_ads' && (
            <>
              <Typography
                style={{
                  marginTop: 20,
                  marginBottom: 4,
                  fontSize: 16,
                }}
                variant="p"
              >
                Lead Status
              </Typography>
              <Select
                onChange={(val) => {
                  sendLeadToMeta(String(val?.value));
                }}
                placeholder="Select Event Type"
                options={Object.entries(leadStatuses).map(([key, value]) => ({
                  value: key,
                  label: value,
                }))}
                value={
                  get(data, 'meta_event_type')
                    ? {
                        value: String(get(data, 'meta_event_type', '')),
                        label:
                          leadStatuses[
                            get(
                              data,
                              'meta_event_type',
                              ''
                            ) as keyof typeof leadStatuses
                          ],
                      }
                    : undefined
                }
              />
            </>
          )}
          {origin[data.request_origin as keyof typeof origin] !== 'app' &&
            !isPrescriber && (
              <PreferenceTime
                isUrgent={data?.is_urgent_delivery}
                onUpdatePreference={onUpdatePreference}
                preference_time={data.preference_time}
                preference_date={data.preference_date}
                flag_reason={data?.flag_reason}
                drug={
                  data?.prescriptions.length > 0 ? data?.prescriptions[0] : null
                }
                refetchRequestDetails={refetch}
              />
            )}
          {Boolean(data?.rx2go_id) && (
            <Rx2GoDetails
              data={rx2goDetails}
              isLoading={isRx2GoDetailsLoading}
            />
          )}
        </div>
      </div>
      <RefillHandler refetch={refetch} ref={refillRef} />
      <Modal
        isOpen={modalOpen}
        onClose={handleModalClose}
        className={styles.list_wrapper}
      >
        <Typography component="p" className={styles.modalDesc} variant="h2">
          Select Delivery Address:
        </Typography>
        <div className={styles.optionWrapper}>
          {get(data.customer, 'delivery_addresses', []).map(
            (item: Address, index: Key | null | undefined) => {
              return (
                <label key={index} className={styles.container}>
                  <input
                    type="radio"
                    name="radio"
                    defaultChecked={deliveryAddressId === String(item.id)}
                    onClick={() => setDeliveryAddressId(String(item.id))}
                  />
                  <span className={styles.radioButtonText}>
                    {get(item, 'display_address', '')}
                  </span>
                  {!get(item, 'is_valid', true) && (
                    <span className={styles.wrongAddress}>issue</span>
                  )}
                </label>
              );
            }
          )}
          <div
            onClick={() => setOpenAddressModal((pr) => !pr)}
            className={styles.addAddress}
          >
            <p>+ Add address</p>
            <ArrowIcon
              className={
                openAddressModal ? styles.icon_rotated : styles.arror_icon
              }
            />
          </div>
          {openAddressModal && (
            <ListWrapper
              style={{
                marginTop: 10,
                paddingLeft: 20,
                paddingRight: 20,
                paddingBottom: 15,
              }}
            >
              <FormGroup>
                <Controller
                  name="city"
                  control={control}
                  rules={{required: 'Please, Select the address'}}
                  render={({field, fieldState}) => (
                    <GooglePlaceAutoComplete
                      label="Your address"
                      placeholder="Address"
                      onSelectPlace={onSelectPlace}
                      error={fieldState.error?.message}
                      options={{
                        types: ['address'],
                      }}
                    />
                  )}
                />
                <Controller
                  name="unit_address"
                  control={control}
                  render={({field, fieldState}) => (
                    <TextField
                      label="Unit number"
                      wrapperClass={styles.googleInput}
                      placeholder="Enter unit number"
                      hasError={false}
                      onChange={field.onChange}
                      error={fieldState.error?.message}
                    />
                  )}
                />
              </FormGroup>
              <div
                style={{
                  alignItems: 'center',
                  display: 'flex',
                  flexDirection: 'column',
                  paddingTop: 20,
                }}
              >
                {!!location.latitude && (
                  <MapPreview
                    zoom={15}
                    onDrag={(location) => {
                      setValue('latitude', location.lat);
                      setValue('longitude', location.lon);
                    }}
                    center={[location.latitude, location.longitude]}
                  />
                )}
              </div>

              <div className={styles.actionWrapper}>
                <Button onClick={handleSubmit(handleCreation)} color="green">
                  Add
                </Button>
              </div>
            </ListWrapper>
          )}
        </div>
        <div className={styles.actions}>
          <Button
            color="green"
            onClick={() => addressChangeHandler(deliveryAddressId || 0)}
            size="md"
            loading={addressIsUpdating}
          >
            Submit
          </Button>
        </div>
      </Modal>
      <InsuranceModal
        isOpen={showInsurance}
        onClose={() => setShowInsurance(false)}
        insurance={data?.insurance}
      />

      <Modal
        isOpen={selectCardModal}
        onClose={() => setSelectCardModal(false)}
        className={styles.list_wrapper}
      >
        <Typography component="p" className={styles.modalDesc} variant="h2">
          Select Card to Charge:
        </Typography>
        <div className={styles.optionWrapper}>
          {cards.map((item: any, index: Key | null | undefined) => {
            return (
              <label key={index} className={styles.radioOption}>
                <input
                  type="radio"
                  name="radio"
                  defaultChecked={cardId === item.custom_uuid}
                  onClick={() => setCardIs(item.custom_uuid)}
                />
                <span className={styles.radioButtonText}>
                  {get(item, 'cardholder_name', '')}
                </span>
                <p
                  style={{marginLeft: 'auto'}}
                  className={styles.radioButtonText}
                >
                  **** **** **** {get(item, 'last4', '')}
                </p>
              </label>
            );
          })}
        </div>
        <div className={styles.actions}>
          <Button
            color="green"
            onClick={() => setAccessCardModal(true)}
            size="md"
            loading={addressIsUpdating}
          >
            Submit
          </Button>
        </div>
      </Modal>
      <Modal
        isOpen={accessCardModal}
        onClose={() => setAccessCardModal(false)}
        className={styles.list_wrapper}
      >
        <Typography component="p" className={styles.modalDesc} variant="h2">
          Are you sure you want to charge this card?
        </Typography>
        <div className={styles.card}>
          <div className={styles.item_header}>
            <div>{get(selectedCard, 'cardholder_name', '')}</div>
          </div>
          <div className={styles.row}>
            <div>**** **** **** {get(selectedCard, 'last4', '')}</div>
            {invalidExpiryDate ? (
              <CreditCardType type={selectedCard?.type} />
            ) : (
              <div>
                Expiration: {get(selectedCard, 'exp_month', '')}/
                {get(selectedCard, 'exp_year', '')}
              </div>
            )}
          </div>
        </div>
        <div className={styles.actions}>
          <Button
            color="green"
            onClick={submitSelectedCard}
            size="md"
            loading={addressIsUpdating}
          >
            Charge - {get(selectedCard, 'last4', '')}
          </Button>
        </div>
      </Modal>
      <Modal
        isOpen={isMessageModalOpen}
        onClose={() => {
          setMessageModalOpen(false);
          setMessage('');
          setSelectedTemplate(undefined);
        }}
        onRequestClose={() => {
          setMessageModalOpen(false);
          setMessage('');
        }}
        className={styles.smsModal}
      >
        <Typography variant="h2">
          Send message to {get(data, 'customer.user.first_name', '') as string}{' '}
          {get(data, 'customer.user.last_name', '') as string}
        </Typography>
        <div className={styles.checkboxContainer}>
          <label style={{display: 'flex', alignItems: 'center', gap: 6}}>
            <Checkbox
              name="check"
              className={styles.checkbox}
              checked={sendChannels.sms}
              onChange={(e) =>
                setSendChannels((prev) => ({...prev, sms: e.target.checked}))
              }
            />
            <span>SMS</span>
          </label>
          <label style={{display: 'flex', alignItems: 'center', gap: 6}}>
            <Checkbox
              name="check"
              className={styles.checkbox}
              checked={sendChannels.email}
              onChange={(e) =>
                setSendChannels((prev) => ({...prev, email: e.target.checked}))
              }
            />
            <span>Email</span>
          </label>
          <label style={{display: 'flex', alignItems: 'center', gap: 6}}>
            <Checkbox
              name="check"
              className={styles.checkbox}
              checked={sendChannels.push}
              onChange={(e) =>
                setSendChannels((prev) => ({...prev, push: e.target.checked}))
              }
            />
            <span>Push</span>
          </label>
        </div>
        <textarea
          className={styles.messageTextarea}
          placeholder="Message"
          value={message}
          onChange={(e) => setMessage(e.target.value)}
        />
        <div className={styles.label}>
          <div>Template</div>
          <PlusComponent onClick={() => push('/website/templates/create')} />
        </div>
        <Select
          className={styles.templateSelect}
          placeholder="Select Template"
          options={messageTemplates}
          value={selectedTemplate}
          onChange={(option) => {
            setSelectedTemplate(option!);
            setMessage(option?.value as string);
          }}
        />

        <FormActionGroup className={styles.buttonWrap}>
          <Button onClick={sendMessage} color="blue">
            Send
          </Button>
        </FormActionGroup>
      </Modal>
    </div>
  );
}

export default RequestDetails;
